export const getIcons = (iconName) => {
    if(iconName === "nodejs"){
        return require("../assets/icons/nodejs.svg").default
    }
    else if(iconName === "react"){
        return require("../assets/icons/react.svg").default
    }
    else if(iconName === "vanillajs"){
        return require("../assets/icons/vanillajs.svg").default
    }
    else if(iconName === "vuejs"){
        return require("../assets/icons/vuejs.svg").default
    }
    else if(iconName === "github"){
        return require("../assets/icons/github.svg").default
    }
    else if(iconName === "github2"){
        return require("../assets/icons/github2.svg").default
    }
    else if(iconName === "redux"){
        return require("../assets/icons/redux.svg").default
    }
    else if(iconName === "nuxtjs"){
        return require("../assets/icons/nuxtjs.svg").default
    }
    else if(iconName === "css3"){
        return require("../assets/icons/css3.svg").default
    }
    else if(iconName === "angular"){
        return require("../assets/icons/angular.svg").default
    }
    else if(iconName === "bash"){
        return require("../assets/icons/bash.svg").default
    }
    else if(iconName === "graphql"){
        return require("../assets/icons/graphql.svg").default
    }
    else if(iconName === "perl"){
        return require("../assets/icons/perl.svg").default
    }
    else if(iconName === "linkedin"){
        return require("../assets/icons/linkedin.svg").default
    }
    else if(iconName === "email"){
        return require("../assets/icons/email.svg").default
    }
}